module.exports = __webpack_public_path__ + "img/stock7.69a23160.png";